<form (keydown.enter)="$event.preventDefault()" [formGroup]="productForm">
  <div class="d-flex flex-column">
    <div class="l2-title">
      Product Information
    </div>
    <div *ngIf="false" class="neonDiv">
      <h1 class="neonText">SC4U Target</h1>
    </div>
    <div *ngIf="[companies.SeaIm].includes(company) && (!isDetail || (isDetail && product.imei)) "
         class="item-row mb-8px">
      <div class="item-label">{{ isDetail ? 'IMEI' : 'IMEI/Serial#' }}</div>
      <div class="item-value">
        <input (keydown.enter)="serialCheck('imei')" class="form-control"
               formControlName="imei"
               id="imei-input"
               placeholder="IMEI or Serial Number"
               type="text">
      </div>
      <button (click)="serialCheck('imei')"
              *ngIf="isSerialCheck && !isDetail"
              [disabled]="!form.imei.value"
              class="btn btn-dark btn-serial-check">Check
      </button>
    </div>
    <div *ngIf="![companies.SeaIm].includes(company) || ([companies.SeaIm].includes(company) && isDetail)"
         class="item-row mb-8px">
      <div class="item-label">Serial#</div>
      <div class="item-value">
        <input (keydown.enter)="serialCheck('serial')" class="form-control"
               formControlName="serialNo"
               id="serial-input"
               placeholder="Serial"
               type="text">
      </div>
      <button (click)="serialCheck('serial')"
              *ngIf="isSerialCheck && (!isDetail || (isDetail && isResetProduct))"
              [disabled]="!form.serialNo.value"
              class="btn btn-dark btn-serial-check">Check
      </button>
      <button (click)="resetProduct()"
              *ngIf="isTicketEditable && isDetail && ([companies.Seca].includes(company) && basic?.processType === 'ZR01')"
              [disabled]="!form.serialNo.value"
              class="btn btn-dark btn-serial-check">X
      </button>
    </div>
    <div class="item-row mb-8px">
      <div class="item-label">Model#</div>
      <div class="item-value">
        <input class="form-control" formControlName="modelCode" id="model-input" placeholder="Model" type="text">
      </div>
      <button (click)="serialCheck('model')"
              *ngIf="isModelCheck && !isDetail"
              [disabled]="!form.modelCode.value"
              class="btn btn-dark btn-serial-check">Check
      </button>
    </div>

    <div class="item-row mb-8px">
      <div class="item-label">Product Type</div>
      <div class="item-value d-flex">
        <dp-badge [color]="color.product" [size]="'wd-fit'" [text]="product?.productType"></dp-badge>
        <div class="badge-text ml-8px">{{ product?.groupName }}</div>
      </div>
    </div>

    <div class="item-row mb-8px">
      <div class="item-label">Product Detail</div>
      <div class="item-value">
        <img *ngIf="product?.serialNo" [ngClass]="{'no-img': !product?.modelImageUrl}"
             [src]="product?.modelImageUrl || '/assets/img/no_image.png'"
             class="product-thumb"/>
      </div>

      <div class="item-product-desc d-flex pt-0">
        <img *ngIf="isDacorModel" class="badge-dacor" src="/assets/img/badge-dacor.png">
        <div class="w-100">{{ product?.productName }}</div>
      </div>
    </div>

    <div class="ticket-horizontal-line"></div>

    <div class="l2-title">Warranty</div>
    <div class="item-row mb-8px">
      <div *ngIf="[companies.Sea].includes(company)" class="item-label">Warranty Status</div>
      <div *ngIf="[companies.Sea].includes(company)" class="item-value">{{ product?.warrantyStatus }}</div>
      <div class="item-label">Warranty Type</div>
      <div class="item-value d-flex">
        <dp-badge *ngIf="product?.warrantyTerm" [color]="color.warranty" [size]="'wd-fit'"
                  [text]="product?.warrantyTerm"
                  class="mr-8px"></dp-badge>
        <dp-badge [color]="color.cardStatus" [size]="'wd-fit'" [text]="product?.warrantyException"
                  class="mr-8px"></dp-badge>
        <div class="badge-text">{{ product?.warrantyType }}</div>
      </div>
    </div>
    <div *ngIf="([companies.SeaIm].includes(company) && isAdmin) || [companies.Sea, companies.Seca].includes(company)"
         class="item-row mb-8px">
      <div class="item-label">Part Wty Term</div>
      <div class="item-value">
        {{ product?.partValidDateTo | localDate }}
      </div>
      <div class="item-label">Labor Wty Term</div>
      <div class="item-value">
        {{ product?.laborValidDateTo | localDate }}
      </div>
    </div>
    <div *ngIf="([companies.SeaIm].includes(company) && isAdmin) || [companies.Sea, companies.Seca].includes(company)"
         class="item-row mb-8px">
      <!--<div class="item-label">Redo</div>
      <div class="item-value">
        <ng-container *ngIf="product?.warrantyTerm">
          {{product?.redo | booleanToString}}
        </ng-container>
      </div>-->
      <div *ngIf="![companies.Seca].includes(company)" class="item-label">Manufacture Date</div>
      <div *ngIf="![companies.Seca].includes(company)" class="item-value d-flex">
        {{ product?.manufacturerDate | localDate }}
      </div>
    </div>
    <ng-container
      *ngIf="basic.customerType === Constants.customerType.CUSTOMER
         && (
         ([companies.Sea].includes(company) && (product?.warrantyTerm === OUT_OF_WARRANTY || basic.serviceType === Constants.serviceCode.COSMETIC_REPAIR
         || basic.serviceType === Constants.serviceCode.INSTALL_CHECKING))
         || [companies.Seca].includes(company)
         || ([companies.SeaIm].includes(company) && product?.warrantyTerm === OUT_OF_WARRANTY))">
      <div
        *ngIf="!isDetail && product?.warrantyTerm === OUT_OF_WARRANTY && [companies.Sea, companies.SeaIm].includes(company)"
        class="item-row mb-8px">
        <div *ngIf="[companies.Sea].includes(company)" class="item-warranty-desc">
          Based on our records, Customer product is out of warranty.<br/>
          If customer believes the product is in warranty, please input purchase date and upload the receipt.
        </div>
        <div *ngIf="[companies.SeaIm].includes(company)" class="item-warranty-desc">
          Based on our records, the entered product is out of warranty. <br/>
          If customer believes the product is in warranty, Please call 800-SAMSUNG to provide proof of purchase.
        </div>
      </div>
      <div
        *ngIf="[companies.Sea].includes(company) || ([companies.Seca].includes(company) && !isDealer && isDetail && product)"
        class="item-row mb-8px">
        <div class="item-label">Purchase Date</div>
        <div class="item-value">
          <!--<input type="text" class="form-control" id="purchase-input" formControlName="purchaseDate" placeholder="Purchase Date">-->
          <div class="input-group input-calendar-condition">
            <input
              #dp="bsDatepicker"
              (bsValueChange)="openCalendarValueChange($event)"
              [bsConfig]="bsConfig"
              [maxDate]="maxDate"
              [ngClass]="{'control-required': !product?.purchaseDate && [companies.Sea].includes(company)}"
              [readOnly]="true"
              bsDatepicker
              class="form-control input-search-condition py-2"
              formControlName="purchaseDate"
              placement="top"
              type="text"/>
            <span class="input-group-text bg-transparent">
                <img (click)="dp.toggle()"
                     [attr.aria-expanded]="dp.isOpen"
                     alt=""
                     class="duration-icon" src="assets/img/ico-duration.svg"/>
              </span>
          </div>

        </div>
      </div>
    </ng-container>

    <div *ngIf="[companies.Sea].includes(company)">
      <div
        *ngIf="basic.customerType === Constants.customerType.CUSTOMER
      && (product?.warrantyTerm === OUT_OF_WARRANTY || basic.serviceType === Constants.serviceCode.COSMETIC_REPAIR || basic.serviceType === Constants.serviceCode.INSTALL_CHECKING)
      && !isDetail"
        class="item-row mb-8px">
        <div class="item-label">Receipts</div>
        <div *ngIf="product?.receipt" class="item-w-100 d-flex">
          <span class="receipts-text">{{ product?.receipt }}</span>
          <font-awesome (click)="fileDelete()" [cssClass]="'ml-4px'" [icon]="'fa-regular fa-xmark'"
                        role="button"></font-awesome>
        </div>
        <div *ngIf="!product?.receipt" class="item-value d-flex">
          <div (click)="imgFileInput.click()" class="item-receipts btn-cursor">
            <input [value]="filename" disabled hidden name="filename" placeholder="Select a File">
            <input #imgFileInput (change)="fileSelected($event)" hidden type="file"/>
            <font-awesome [icon]="'fa-light fa-image'" role="button"></font-awesome>
          </div>
        </div>
      </div>
      <div *ngIf="isDetail && (attachment || basic.serviceType === 'SI'); else isNewFile" class="item-row mb-8px">
        <div class="item-label">Receipts</div>
        <div class="item-w-100 d-flex">
          <ng-container *ngIf="(attachment?.tempServerFile)">
          <span (click)="selectFile(false)"
                class="receipts-text btn-cursor">{{ this.attachment?.tempServerFile?.filename }}</span>
          </ng-container>
          <ng-container *ngIf="(!attachment && basic.serviceType === 'SI') else isFile">
            <div class="item-w-100 d-flex">
              <div (click)="bosUpDateFileInput.click()" class="item-receipts btn-cursor">
                <input [value]="filename" disabled hidden name="filename" placeholder="Select a File">
                <input #bosUpDateFileInput (change)="updateFileSelected($event)" hidden type="file"/>
                <font-awesome [icon]="'fa-light fa-image'" role="button"></font-awesome>
              </div>
            </div>
          </ng-container>
          <ng-template #isFile>
            <span (click)="selectFile()" class="receipts-text btn-cursor">{{ this.attachment?.filename }}</span>
            <font-awesome (click)="fileUpdate();" *ngIf="isTicketEditable" [cssClass]="'ml-4px'"
                          [icon]="'fa-regular fa-xmark'"
                          role="button"></font-awesome>
          </ng-template>
        </div>
      </div>
      <ng-template #isNewFile>
        <div *ngIf="isUpdateBos" class="item-row mb-8px">
          <div class="item-label">Receipts</div>
          <div class="item-w-100 d-flex">
            <div (click)="bosUpDateFileInput.click()" class="item-receipts btn-cursor">
              <input [value]="filename" disabled hidden name="filename" placeholder="Select a File">
              <input #bosUpDateFileInput (change)="updateFileSelected($event)" hidden type="file"/>
              <font-awesome [icon]="'fa-light fa-image'" role="button"></font-awesome>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
    <div *ngIf="[companies.Seca].includes(company)">
      <div *ngIf="!isDetail" class="item-row mb-8px">
        <div class="item-label">Receipts</div>
        <div *ngIf="product?.receipt" class="item-w-100 d-flex">
          <span class="receipts-text">{{ product?.receipt }}</span>
          <font-awesome (click)="fileDelete()" [cssClass]="'ml-4px'" [icon]="'fa-regular fa-xmark'"
                        role="button"></font-awesome>
        </div>
        <div *ngIf="!product?.receipt" class="item-value d-flex">
          <div (click)="imgFileInput.click()" class="item-receipts btn-cursor">
            <input [value]="filename" disabled hidden name="filename" placeholder="Select a File">
            <input #imgFileInput (change)="fileSelected($event)" hidden type="file"/>
            <font-awesome [icon]="'fa-light fa-image'" role="button"></font-awesome>
          </div>
        </div>
      </div>
      <ng-container *ngIf="isDetail && attachment && !ticketService.resetSerial; else isResetSerial">
        <div class="item-row mb-8px">
          <div class="item-label">Receipts</div>
          <div class="item-w-100 d-flex">
            <ng-container *ngIf="attachment.tempServerFile; else isFile">
              <span (click)="selectFile(true)"
                    class="receipts-text btn-cursor">{{ this.attachment?.tempServerFile?.filename }}</span>
            </ng-container>
            <ng-template #isFile>
              <span (click)="selectFile()" class="receipts-text btn-cursor">{{ this.attachment?.filename }}</span>
              <font-awesome (click)="fileUpdate();" *ngIf="isTicketEditable" [cssClass]="'ml-4px'"
                            [icon]="'fa-regular fa-xmark'"
                            role="button"></font-awesome>
            </ng-template>
          </div>
        </div>
      </ng-container>
      <ng-template #isResetSerial>
        <ng-container *ngIf="ticketService.resetSerial; else isNewFile">
          <div class="item-row mb-8px">
            <div class="item-label">Receipts</div>
            <div *ngIf="product?.receipt" class="item-w-100 d-flex">
              <span class="receipts-text">{{ product?.receipt }}</span>
              <font-awesome (click)="fileDelete()" [cssClass]="'ml-4px'" [icon]="'fa-regular fa-xmark'"
                            role="button"></font-awesome>
            </div>
            <div *ngIf="!product?.receipt" class="item-value d-flex">
              <div (click)="imgFileInput.click()" class="item-receipts btn-cursor">
                <input [value]="filename" disabled hidden name="filename" placeholder="Select a File">
                <input #imgFileInput (change)="fileSelected($event)" hidden type="file"/>
                <font-awesome [icon]="'fa-light fa-image'" role="button"></font-awesome>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-template #isNewFile>
          <div *ngIf="isDetail && !attachment" class="item-row mb-8px">
            <div class="item-label">Receipts</div>
            <div class="item-w-100 d-flex">
              <div (click)="bosUpDateFileInput.click()" class="item-receipts btn-cursor">
                <input [value]="filename" disabled hidden name="filename" placeholder="Select a File">
                <input #bosUpDateFileInput (change)="updateFileSelected($event)" hidden type="file"/>
                <font-awesome [icon]="'fa-light fa-image'" role="button"></font-awesome>
              </div>
            </div>
          </div>
        </ng-template>
      </ng-template>
    </div>
    <div class="ticket-horizontal-line"></div>
  </div>
</form>
